export default __webpack_public_path__ + "static/media/chart_staking.a3f9b98f.png";